import {sortBy} from 'lodash'

import {Config, ConfigDto} from '../types'

import {mapShifts} from './shift.mappers'

export const mapPlantConfig = (plantConfig: ConfigDto): Config => {
  return {
    ...plantConfig,
    kilnStoppageCodes: sortBy(plantConfig.kilnStoppageCodes, 'description'),
    finishMillStoppageCodes: sortBy(plantConfig.finishMillStoppageCodes, 'description'),
    rawMillStoppageCodes: sortBy(plantConfig.rawMillStoppageCodes, 'description'),
    alternativeFuelInstallationStoppageCodes: sortBy(
      plantConfig.alternativeFuelInstallationStoppageCodes,
      'description'
    ),
    shifts: mapShifts(plantConfig.shifts)
  }
}
